import { inject, injectable } from 'inversify';
import { TYPES } from '@Types';
import { ArmyMapper } from '../../ninthAge/ArmyMapper';
import { army_list_txt_formated } from '@Api';
import { ArmyListUnitFormatedMapper } from './army-list-unit-formated.mapper';
import { ArmyList, ArmyListFormated, ArmyListSize, VersionGame } from '@Models';
import { FormatErrorMapper } from './format-error.mapper';
import { v4 as uuidv4 } from 'uuid';

@injectable()
export class ArmyListFormatedMapper {
  @inject(TYPES.Mapper.ArmyMapper) private _armyMapper!: ArmyMapper;
  @inject(TYPES.Mapper.ArmyListUnitFormatedMapper)
  private _armyListUnitFormatedMapper!: ArmyListUnitFormatedMapper;
  @inject(TYPES.Mapper.FormatErrorMapper)
  private _formatErrorMapper!: FormatErrorMapper;

  public map(item: army_list_txt_formated): ArmyListFormated {
    return {
      original: item.original,
      formated: item.formated,
      points: item.points,
      total: item.total,
      errors: item.validation.errors.map((error) =>
        this._formatErrorMapper.map(error),
      ),
      versionId: item.version_id,
      army: item.army ? this._armyMapper.mapSmall(item.army) : null,
      armyOrganisationId: item.army_organisation_id ?? null,
      units: item.units.map((u) => this._armyListUnitFormatedMapper.map(u)),
    } satisfies ArmyListFormated as ArmyListFormated;
  }

  public mapToBuilder(item: ArmyListFormated): ArmyList {
    return {
      id: uuidv4(),
      folderId: null,
      versionId: item.versionId,
      armyId: item.army?.id ?? 0,
      updatedAt: 0,
      creator: '',
      army_list_units: item.units.map((unit, index) =>
        this._armyListUnitFormatedMapper.mapToBuilder(unit, index + 1),
      ),
      max: 4500,
      name: '',
      notes: null,
      army_organisation_id: item.armyOrganisationId ?? 0,
      points: item.total ?? 4500,
      isPrivate: false,
      versionName: '',
      initials: '',
      largeLogo: null,
      versionColor: '',
      size: ArmyListSize.Standard,
      versionGame: VersionGame.NinthAge,
    } satisfies ArmyList as ArmyList;
  }
}
